import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./AddNewAtmForm.css";
import Modal from "react-bootstrap/Modal";
import { XCircleblack } from "../../../../Components/IconComponents";
import MapWrapper from "../../../../Components/UiComponents/MapWrapper/MapWrapper";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse, parseISO } from "date-fns";
import {
  getData,
  postDataWithBody,
  putDataWithBody,
} from "../../../../Services/Services";
import {
  findRegionsByUser,
  getallBanksByRole,
  getbarches,
  getThemeURL,
  saveatmdetails,
  updateAtm,
} from "../../../../Services/EndPoints";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../Components/UiComponents/Loader/Loader";
import MapWrapperForEdit from "../../IncidentManagement/AddIncidentForm/MapWarapperForEdit";
// import LocationAtmComplete from "./LocationAtmComplete";

// Create/ Edit ATM component function
const AddNewAtmForm = () => {
  const location = useLocation();
  const { isTextFieldDisable, data, edit } = location.state || {};

  const [showMapModal, setShowMapModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [coordinates, setCoordinates] = useState([
    {
      y: 85.562, // default longitude
      x: 25.747, // default latitude
    },
  ]);
  const [zoomLevel, setZoomLevel] = useState(8);
  const [mapKey, setMapKey] = useState(0);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [banks, setBanks] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [availableBranches, setAvailableBranches] = useState([]);
  const [userId, setUserId] = useState(null);
  // Form validation state
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  // Initial form state (for resetting)
  const initialFormState = {
    atmName: "",
    district: "",
    atmCode: "",
    active: false,
    activedate: format(new Date(), "dd/MM/yyyy"),
    addressLine1: "",
    addressLine2: "",
    pincode: "",
    city: "",
    mandal: "",
    state: "Bihar", // Set Bihar as default state
    bankName: "",
    branch: "",
    latitude: "",
    longitude: "",
    manufacturer: "",
    model: "",
    serialNumber: "",
    deviceType: "",
    ipAddress: "",
    macAddress: "",
  };

  // Form data state
  const [formData, setFormData] = useState(initialFormState);

  // Track the active tab
  const [activeTab, setActiveTab] = useState("ATM Details");

  // Required fields with specific error messages
  const requiredFieldMessages = {
    atmName: "ATM Name is required",
    district: "Please select a District",
    atmCode: "ATM Code is required",
    addressLine1: "Address is required",
    pincode: "Pincode is required",
    city: "City is required",
    mandal: "Mandal is required", // Added mandal as required field
    state: "Please select a State",
    bankName: "Bank Name is required",
    branch: "Branch Name is required",
  };

  // Get list of required fields
  const requiredFields = Object.keys(requiredFieldMessages);

  useEffect(() => {
    getUserProfile();
    fetchdistricts();
    fetchuerProfile();
  }, []);

  useEffect(() => {
    // If in edit mode and data is available, populate the form
    if (edit && data) {
      populateFormWithData();
    }
  }, [edit, data, banks]);

  const populateFormWithData = () => {
    if (!data) return;

    // Extract the data from the data object
    const atmData = {
      atmName: data.name || "",
      district: data.district || "",
      atmCode: data.code || "",
      active: data.activeStatus || false,
      activedate: data.entryDate
        ? format(new Date(data.entryDate), "dd/MM/yyyy")
        : "",
      addressLine1: data.addressLine || "",
      pincode: data.pinCode || "",
      city: data.city || "",
      mandal: data.mandal || "",
      state: data.state || "Bihar",
      bankName: data.bankId || "",
      branch: data.branchId || "",
      latitude: data.latitude || "",
      longitude: data.longitude || "",
    };

    setFormData(atmData);

    // Set coordinates for the map
    if (data.latitude && data.longitude) {
      setCoordinates([
        {
          y: data.longitude,
          x: data.latitude,
        },
      ]);
      // setMapCenterCoordinates({
      //   y: data.longitude,
      //   x: data.latitude,
      // });
    }

    // If bank is selected, fetch branches
    if (data.bankId) {
      fetchBranches(data.bankId);
    }
  };

  //User Profile API Call
  const fetchuerProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        fetchBanks(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
    let admin_role;

    if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    } else if (profile.is_admin === true) {
      admin_role = "HO";
    } else {
      admin_role = "U";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  //Fetch Bank details Api Call
  const fetchBanks = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanks(response);
      } else {
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  };
  //Fetch districts Api Call
  const fetchdistricts = async () => {
    try {
      const response = await getData(findRegionsByUser);
      console.log("responsedis", response);
      if (response && Array.isArray(response)) {
        setDistricts(response);
      } else {
        toast.error("Failed to load banks data");
      }
    } catch (error) {}
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "bankName") {
      // When bank is changed, reset branch selection and fetch branches
      setFormData({
        ...formData,
        [name]: value,
        branch: "", // Reset branch selection
      });

      // Fetch branches from API for the selected bank
      fetchBranches(value);
    } else {
      // Handle other form field changes normally
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }

    if (name === "atmName") {
      const error = validateAtmName(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error, // Show error immediately
      }));
    } else if (errors[name]) {
      // Clear other field errors if they exist
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null,
      }));
    }
    // Clear error when field is changed
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }

    // Hide success message when user starts editing again
    if (showSuccessMsg) {
      setShowSuccessMsg(false);
    }
  };
  const fetchBranches = async (bankId) => {
    if (!bankId) {
      setAvailableBranches([]);
      return;
    }

    // setIsBranchLoading(true);
    try {
      // Replace with your actual API endpoint
      const response = await getData(getbarches.replace("ID", bankId));
      setAvailableBranches(response);
    } catch (error) {
      console.error("Error fetching branches:", error);
      setAvailableBranches([]);
    } finally {
      // setIsBranchLoading(false);
    }
  };
  const validateAtmName = (value) => {
    if (!value || !value.trim()) {
      return "ATM Name is required";
    }
    if (value.trim().length < 3) {
      return "ATM Name must be at least 3 characters";
    }
    if (value.trim().length > 50) {
      return "ATM Name must be less than 50 characters";
    }
    if (!/^[a-zA-Z0-9 ]+$/.test(value)) {
      return "Only letters, numbers, and spaces allowed";
    }
    return ""; // No error
  };

  const validateAtmCode = (value, isSubmitting = false) => {
    if (!value || !value.trim()) {
      return "ATM Code is required";
    }

    // Only show format errors when submitting or when field is complete

    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
      return "ATM Code must follow the format: 4 letters, 0, and 6 alphanumeric characters";
    }

    return ""; // No error
  };

  const validateAddress = (value) => {
    if (!value || !value.trim()) {
      return "Address is required";
    }
    if (value.trim().length < 5) {
      return "Address must be at least 5 characters";
    }
    if (value.trim().length > 100) {
      return "Address cannot exceed 100 characters";
    }
    return "";
  };

  const validateCity = (value) => {
    if (!value || !value.trim()) {
      return "City is required";
    }
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      return "City must contain letters and spaces only";
    }
    if (value.trim().length > 50) {
      return "City must be less than 50 characters";
    }
    return "";
  };

  const validateMandal = (value) => {
    if (!value || !value.trim()) {
      return "Mandal is required";
    }
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      return "Mandal must contain letters and spaces only";
    }
    if (value.trim().length > 50) {
      return "Mandal must be less than 50 characters";
    }
    return "";
  };

  const validatePinCode = (value) => {
    if (!value || !value.trim()) {
      return "Pincode is required";
    }

    // Show validation as user types
    if (value.length > 0 && value.length < 6) {
      return "Pincode must be 6 digits";
    }

    if (value.length === 6) {
      if (!/^[1-9][0-9]{5}$/.test(value)) {
        return "Pincode must start with a non-zero digit";
      }
    }

    return ""; // No error
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Re-validate ATM Name (in case user skips typing)
    const atmNameError = validateAtmName(formData.atmName);
    if (atmNameError) {
      newErrors.atmName = atmNameError;
      isValid = false;
    }

    // Validate ATM Code with strict validation
    const atmCodeError = validateAtmCode(formData.atmCode, true);
    if (atmCodeError) {
      newErrors.atmCode = atmCodeError;
      isValid = false;
    }

    // Validate all fields with strict validation
    const addressError = validateAddress(formData.addressLine1);
    if (addressError) {
      newErrors.addressLine1 = addressError;
      isValid = false;
    }

    const cityError = validateCity(formData.city);
    if (cityError) {
      newErrors.city = cityError;
      isValid = false;
    }

    const mandalError = validateMandal(formData.mandal);
    if (mandalError) {
      newErrors.mandal = mandalError;
      isValid = false;
    }

    const pincodeError = validatePinCode(formData.pincode);
    if (pincodeError || formData.pincode.length !== 6) {
      newErrors.pincode = pincodeError || "Pincode must be 6 digits";
      isValid = false;
    }
    // Check each required field
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field] === "") {
        newErrors[field] = requiredFieldMessages[field];
        isValid = false;
      }
    });

    // Validate pincode (6 digits)
    if (formData.pincode && !/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = "Pincode must be 6 digits";
      isValid = false;
    }

    // In validateForm function:
    if (formData.addressLine1) {
      if (formData.addressLine1.length < 3) {
        newErrors.addressLine1 = "Address must be at least 3 characters long";
        isValid = false;
      } else if (formData.addressLine1.length > 100) {
        newErrors.addressLine1 = "Address cannot exceed 100 characters";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  const resetForm = () => {
    setFormData(initialFormState);
    setErrors({});
    setIsSubmitted(false);
    setCoordinates([
      {
        y: 85.562, // default longitude
        x: 25.747, // default latitude
      },
    ]);
    setMapKey((prevKey) => prevKey + 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (validateForm()) {
      if (edit) {
        console.log("hiii");
        updateAtmApi();
      } else {
        console.log("hekkk");
        createatmapi();
      }
    } else {
      console.log("Form has errors");
      toast.error("Please correct the validation errors", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createatmapi = async () => {
    try {
      let input = {
        name: formData.atmName,
        district: formData.district,
        code: formData.atmCode,
        activeStatus: formData.active,
        entryDate: formData.activedate
          ? format(
              parse(formData.activedate, "dd/MM/yyyy", new Date()),
              "yyyy-MM-dd"
            )
          : "",
        addressLine: formData.addressLine1 || "",
        pinCode: formData.pincode,
        city: formData.mandal,
        mandal: formData.mandal,
        state: formData.state,
        latitude: formData.latitude,
        longitude: formData.longitude,
        is_deleted: false,
        created_by: userId,
        bankId: formData.bankName,
        branchId: formData.branch,
        remarks: "",
      };
      setLoader(true);
      const response = await postDataWithBody(saveatmdetails, input, {});
      if (response.status === "success") {
        toast.success(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setLoader(false);
        // Reset form after successful submission
        resetForm();
        navigate("../all-atms");

        // Call onSuccess if provided to trigger parent data refresh
        // if (onSuccess && typeof onSuccess === 'function') {
        //     onSuccess();
        // }
      } else {
        setLoader(false);
        toast.error(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      setLoader(false);
      console.error("Error saving alert:", error);
      toast.error("Failed to save alert", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const updateAtmApi = async () => {
    try {
      let input = {
        id: data.id, // Make sure to include the ID for updating
        name: formData.atmName,
        district: formData.district,
        code: formData.atmCode,
        activeStatus: formData.active,
        entryDate: formData.activedate
          ? format(
              parse(formData.activedate, "dd/MM/yyyy", new Date()),
              "yyyy-MM-dd"
            )
          : "",
        addressLine: formData.addressLine1 || "",
        pinCode: formData.pincode,
        city: formData.mandal,
        mandal: formData.mandal,
        state: formData.state,
        latitude: formData.latitude,
        longitude: formData.longitude,
        is_deleted: false,
        updated_by: userId,
        bankId: formData.bankName,
        branchId: formData.branch,
        remarks: "",
      };
      setLoader(true);
      const response = await putDataWithBody(updateAtm, input, {});
      if (response.status === "success") {
        toast.success(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setLoader(false);
        navigate("../all-atms");
      } else {
        setLoader(false);
        toast.error(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      setLoader(false);
      console.error("Error updating ATM:", error);
      toast.error("Failed to update ATM", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const moveToNextTab = () => {
    handleSubmit(new Event("submit"));
  };

  const openMapModal = () => {
    setShowMapModal(true);
  };

  const closeMapModal = () => {
    setShowMapModal(false);
  };

  // const updateMapLocation = (lat, lng) => {
  //   setCoordinates([{ y: lng, x: lat }]);
  //   setFormData({
  //     ...formData,
  //     latitude: lat,
  //     longitude: lng,
  //   });
  //   // setMapCenterCoordinates({
  //   //   y: lng,
  //   //   x: lat,
  //   // });
  //   setZoomLevel(16);
  //   setMapKey((prevKey) => prevKey + 1);
  // };

  const chooseCoordinates = (longitude, latitude) => {
    // Update form data
    setFormData({
      ...formData,
      longitude: longitude,
      latitude: latitude,
    });

    // Update coordinates for the map
    setCoordinates([
      {
        y: longitude,
        x: latitude,
      },
    ]);

    // Set center coordinates for the map
    // setMapCenterCoordinates({
    //   y: longitude,
    //   x: latitude,
    // });

    // Optional: Reset map key to force re-render
    setMapKey((prevKey) => prevKey + 1);
  };

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

    if (type === "checkbox" && id === "activeStatusCheck") {
      setFormData({ ...formData, active: checked });
    }
  };

  // Style for required field indicator
  const requiredFieldStyle = {
    color: "red",
    marginLeft: "3px",
  };

  // Helper function to display error message
  const renderError = (fieldName) => {
    return errors[fieldName] && isSubmitted ? (
      <div
        className="error-message-atm"
        style={{ color: "#dd4e57", fontSize: "12px", marginTop: "5px" }}
      >
        {errors[fieldName]}
      </div>
    ) : null;
  };

  // Helper function to add required field indicator
  const renderLabel = (fieldName, displayName) => (
    <label
      htmlFor={fieldName}
      style={{
        fontSize: "15px",
        fontFamily: "Poppins",
        fontWeight: "400",
        color: "#353535",
      }}
    >
      {displayName}
      {requiredFields.includes(fieldName) && (
        <span style={requiredFieldStyle}>*</span>
      )}
    </label>
  );

  // Handle cancel button click - show confirmation modal
  const handleCancel = () => {
    setShowCancelModal(true);
  };

  // Confirm cancel - reset form
  const confirmCancel = () => {
    if (edit) {
      navigate("../all-atms");
    } else {
      resetForm();
    }
    setShowCancelModal(false);
  };

  // Close cancel modal without resetting
  const closeCancelModal = () => {
    setShowCancelModal(false);
  };
  const mapCoordinates = [
    {
      x: formData.latitude,
      y: formData.longitude,
      locationId: 1,
    },
  ];
  return (
    <>
      <div className="add-atm-container">
        <form onSubmit={handleSubmit}>
          {/* ATM Details Tab */}
          {activeTab === "ATM Details" && (
            <div className="form-section" style={{}}>
              <div className="form-row" style={{ gap: "10px" }}>
                <div className="form-group">
                  {renderLabel("atmName", "ATM Name")}
                  <input
                    type="text"
                    id="atmName"
                    name="atmName"
                    value={formData.atmName}
                    onChange={handleChange} // Triggers validation on every keystroke
                    maxLength={50} // Prevent exceeding max length
                    className={`form-control branch-input-form-control ${
                      errors.atmName ? "is-invalid" : "" // Show red border if error exists
                    }`}
                  />
                  {/* Show error message as user types */}
                  {errors.atmName && (
                    <div
                      className="error-message-atm"
                      style={{
                        color: "#dd4e57",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    >
                      {errors.atmName}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  {renderLabel("atmCode", "ATM Code")}
                  <input
                    type="text"
                    id="atmCode"
                    name="atmCode"
                    value={formData.atmCode}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Simply update the state with whatever is typed
                      handleChange(e);

                      // Validate on every keystroke but don't restrict input
                      const error = validateAtmCode(value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        atmCode: error,
                      }));
                    }}
                    maxLength={11}
                    className={`form-control branch-input-form-control ${
                      errors.atmCode && isSubmitted ? "is-invalid" : ""
                    }`}
                  />
                  {errors.atmCode && (
                    <div
                      className="error-message-atm"
                      style={{
                        color: "#dd4e57",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    >
                      {errors.atmCode}
                    </div>
                  )}
                </div>

                <div className="col-3 mb-3">
                  <label
                    htmlFor="activationDate"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "15px",
                      fontWeight: "400",
                      color: "#353535",
                    }}
                  >
                    Active Status
                  </label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      className="form-check-input branch-active-status-checkbox"
                      type="checkbox"
                      id="activeStatusCheck"
                      checked={formData.active}
                      onChange={handleInputChange}
                    />
                    <input
                      type="date"
                      className="custom-date-input form-control"
                      style={{paddingBottom: "7px"}}
                      value={
                        formData.activedate
                          ? format(
                              parse(
                                formData.activedate,
                                "dd/MM/yyyy",
                                new Date()
                              ),
                              "yyyy-MM-dd"
                            )
                          : format(new Date(), "yyyy-MM-dd")
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          const date = parseISO(e.target.value);
                          const formatted = format(date, "dd/MM/yyyy");
                          setFormData({ ...formData, activedate: formatted });
                        } else {
                          setFormData({ ...formData, activedate: "" });
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="form-row"
                style={{ display: "flex", gap: "10px" }}
              >
                <div
                  className="form-group"
                  style={{ flex: 1, marginRight: "-10px", flexBasis: "14%" }}
                >
                  {renderLabel("bankName", "Bank Name")}
                  <select
                    id="bankName"
                    name="bankName"
                    value={formData.bankName}
                    onChange={handleChange}
                    className={`form-select branch-input-form-control ${
                      errors.bankName && isSubmitted ? "is-invalid" : ""
                    }`}
                  >
                    <option value="" style={{ fontSize: "14px" }}>
                      Select Bank Name
                    </option>
                    {banks.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.bankName}
                      </option>
                    ))}
                  </select>
                  {renderError("bankName")}
                </div>

                <div
                  className="form-group"
                  style={{ flexBasis: "14%", marginLeft: "12px" }}
                >
                  {renderLabel("branch", "Branch Name")}
                  <select
                    id="branch"
                    name="branch"
                    value={formData.branch}
                    onChange={handleChange}
                    className={`form-control ${
                      errors.branch && isSubmitted ? "is-invalid" : ""
                    }`}
                    disabled={!formData.bankName}
                  >
                    <option value="" style={{ fontSize: "14px" }}>
                      Select Branch
                    </option>
                    {availableBranches.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.branchName}
                      </option>
                    ))}
                  </select>
                  {renderError("branch")}
                </div>
                <div className="form-group" style={{ flex: 1 }}></div>
              </div>

              <div className="location-section">
                {!edit && (
                  <div
                    className="form-row"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <h3
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "15px",
                        fontWeight: "700",
                        color: "#1a7a73",
                        textDecoration: "underline",
                        marginLeft: "10px",
                      }}
                    >
                      ATM Address
                    </h3>
                  </div>
                )}
                <div className="form-row">
                  {!edit && (
                    <>
                      <div className="form-group ">
                        <label
                          htmlFor="addressLine1"
                          style={{
                            fontSize: "15px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            color: "#353535",
                          }}
                        >
                          {renderLabel("addressLine1", "Address")}
                        </label>
                        <textarea
                          // type="text"
                          id="addressLine1"
                          name="addressLine1"
                          value={formData.addressLine1}
                          onChange={(e) => {
                            handleChange(e);
                            const error = validateAddress(e.target.value);
                            setErrors((prev) => ({
                              ...prev,
                              addressLine1: error,
                            }));
                          }}
                          className={`form-control branch-input-form-control ${
                            errors.addressLine1 && isSubmitted
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        {errors.addressLine1 && (
                          <div
                            className="error-message-atm"
                            style={{
                              color: "#dd4e57",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.addressLine1}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        {renderLabel("mandal", "Mandal")}
                        <input
                          type="text"
                          id="mandal"
                          name="mandal"
                          value={formData.mandal}
                          onChange={(e) => {
                            handleChange(e);
                            const error = validateMandal(e.target.value);
                            setErrors((prev) => ({ ...prev, mandal: error }));
                          }}
                          className={`form-control branch-input-form-control ${
                            errors.mandal && isSubmitted ? "is-invalid" : ""
                          }`}
                        />
                        {errors.mandal && (
                          <div
                            className="error-message-atm"
                            style={{
                              color: "#dd4e57",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.mandal}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        {renderLabel("city", "City")}
                        <input
                          type="text"
                          id="city"
                          name="city"
                          value={formData.city}
                          onChange={(e) => {
                            handleChange(e);
                            const error = validateCity(e.target.value);
                            setErrors((prev) => ({ ...prev, city: error }));
                          }}
                          className={`form-control branch-input-form-control ${
                            errors.city && isSubmitted ? "is-invalid" : ""
                          }`}
                        />
                        {errors.city && (
                          <div
                            className="error-message-atm"
                            style={{
                              color: "#dd4e57",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.city}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        {renderLabel("district", "District")}
                        <select
                          id="district"
                          name="district"
                          value={formData.district}
                          onChange={handleChange}
                          className={`form-select branch-input-form-control ${
                            errors.district && isSubmitted ? "is-invalid" : ""
                          }`}
                        >
                          <option value="" style={{ fontSize: "14px" }}>
                            Select District
                          </option>
                          {districts.map((district) => (
                            <option key={district.id} value={district.value}>
                              {district.value}
                            </option>
                          ))}
                        </select>
                        {renderError("district")}
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group" style={{ marginLeft: "-19px" }}>
                  {edit && (
                    <>
                      <h3
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "15px",
                          fontWeight: "700",
                          color: "#1a7a73",
                          textDecoration: "underline",
                          marginLeft: "10px",
                        }}
                      >
                        ATM Address
                      </h3>
                      <div className="row">
                        {/* Left side: Form Fields */}
                        <div className="col-md-6">
                          <div className="form-group ">
                            <label
                              htmlFor="addressLine1"
                              style={{
                                fontSize: "15px",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                color: "#353535",
                              }}
                            >
                              {renderLabel("addressLine1", "Address")}
                            </label>
                            <textarea
                              // type="text"
                              id="addressLine1"
                              name="addressLine1"
                              value={formData.addressLine1}
                              onChange={(e) => {
                                handleChange(e);
                                const error = validateAddress(e.target.value);
                                setErrors((prev) => ({
                                  ...prev,
                                  addressLine1: error,
                                }));
                              }}
                              className={`form-control branch-input-form-control ${
                                errors.addressLine1 && isSubmitted
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            {errors.addressLine1 && (
                              <div
                                className="error-message-atm"
                                style={{
                                  color: "#dd4e57",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                {errors.addressLine1}
                              </div>
                            )}
                          </div>
                          <div className="form-group">
                            {renderLabel("mandal", "Mandal")}
                            <input
                              type="text"
                              id="mandal"
                              name="mandal"
                              value={formData.mandal}
                              onChange={(e) => {
                                handleChange(e);
                                const error = validateMandal(e.target.value);
                                setErrors((prev) => ({
                                  ...prev,
                                  mandal: error,
                                }));
                              }}
                              className={`form-control branch-input-form-control ${
                                errors.mandal && isSubmitted ? "is-invalid" : ""
                              }`}
                            />
                            {errors.mandal && (
                              <div
                                className="error-message-atm"
                                style={{
                                  color: "#dd4e57",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                {errors.mandal}
                              </div>
                            )}
                          </div>
                          <div className="form-group">
                            {renderLabel("city", "City")}
                            <input
                              type="text"
                              id="city"
                              name="city"
                              value={formData.city}
                              onChange={(e) => {
                                handleChange(e);
                                const error = validateCity(e.target.value);
                                setErrors((prev) => ({ ...prev, city: error }));
                              }}
                              className={`form-control branch-input-form-control ${
                                errors.city && isSubmitted ? "is-invalid" : ""
                              }`}
                            />
                            {errors.city && (
                              <div
                                className="error-message-atm"
                                style={{
                                  color: "#dd4e57",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                {errors.city}
                              </div>
                            )}
                          </div>
                          <div className="form-group">
                            {renderLabel("district", "District")}
                            <select
                              id="district"
                              name="district"
                              value={formData.district}
                              onChange={handleChange}
                              className={`form-select branch-input-form-control ${
                                errors.district && isSubmitted
                                  ? "is-invalid"
                                  : ""
                              }`}
                            >
                              <option value="" style={{ fontSize: "14px" }}>
                                Select District
                              </option>
                              {districts.map((district) => (
                                <option
                                  key={district.id}
                                  value={district.value}
                                >
                                  {district.value}
                                </option>
                              ))}
                            </select>
                            {renderError("district")}
                          </div>

                          <div className="form-group">
                            {renderLabel("pincode", "Pincode")}
                            <input
                              type="text"
                              id="pincode"
                              name="pincode"
                              value={formData.pincode}
                              onChange={(e) => {
                                // Allow any input without filtering
                                handleChange(e);

                                // Validate on every keystroke
                                const error = validatePinCode(e.target.value);
                                setErrors((prev) => ({
                                  ...prev,
                                  pincode: error,
                                }));
                              }}
                              maxLength={6}
                              className={`form-control branch-input-form-control ${
                                errors.pincode && isSubmitted
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            {errors.pincode && (
                              <div
                                className="error-message-atm"
                                style={{
                                  color: "#dd4e57",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                {errors.pincode}
                              </div>
                            )}
                          </div>
                          <div className="form-group ">
                            <label
                              style={{
                                fontSize: "15px",
                                fontFamily: "Poppins",
                                fontWeight: "400",
                                color: "#353535",
                              }}
                            >
                              Latitude
                            </label>
                            <input
                              type="text"
                              value={formData.latitude}
                              readOnly
                              className="form-control branch-input-form-control"
                            />
                          </div>
                          <div className="form-group ">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <label
                                style={{
                                  fontSize: "15px",
                                  fontFamily: "Poppins",
                                  fontWeight: "400",
                                  color: "#353535",
                                }}
                              >
                                Longitude
                              </label>
                              <span
                                className="text-primary"
                                onClick={
                                  !isTextFieldDisable ? openMapModal : undefined
                                }
                                style={{
                                  cursor: isTextFieldDisable
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: isTextFieldDisable ? 0.5 : 1,
                                  fontSize: "15px",
                                  fontFamily: "Poppins",
                                  fontWeight: "400",
                                  color: "#353535",
                                  marginRight: "10px",
                                }}
                              >
                                Locate on Map
                              </span>
                            </div>
                            <input
                              type="text"
                              value={formData.longitude}
                              readOnly
                              className="form-control branch-input-form-control"
                            />
                          </div>
                        </div>

                        {/* Right side: Map */}
                        <div
                          className="col-md-6 d-flex align-items-start justify-content-center"
                          style={{ marginTop: "20px", width: "52%" }}
                        >
                          {edit && (
                            <MapWrapperForEdit
                              title="ATM"
                              containerStyles={{
                                width: "100%",
                                height: "410px", // adjust as needed
                                display: "flex",
                                flexDirection: "column",
                              }}
                              headerStyles={{
                                backgroundColor: "#1a7a73",
                                color: "white",
                                padding: "8px 16px",
                              }}
                              bodyStyles={{
                                flex: 1,
                                overflow: "hidden",
                              }}
                              coordinates={mapCoordinates}
                              zoom={13}
                              popUpShow={true}
                              atmEdit={true}
                            />
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {!edit && (
                  <>
                    <div className="form-row"></div>

                    <div className="form-row">
                      <div className="form-group">
                        {renderLabel("pincode", "Pincode")}
                        <input
                          type="text"
                          id="pincode"
                          name="pincode"
                          value={formData.pincode}
                          onChange={(e) => {
                            // Allow any input without filtering
                            handleChange(e);

                            // Validate on every keystroke
                            const error = validatePinCode(e.target.value);
                            setErrors((prev) => ({ ...prev, pincode: error }));
                          }}
                          maxLength={6}
                          className={`form-control branch-input-form-control ${
                            errors.pincode && isSubmitted ? "is-invalid" : ""
                          }`}
                        />
                        {errors.pincode && (
                          <div
                            className="error-message-atm"
                            style={{
                              color: "#dd4e57",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.pincode}
                          </div>
                        )}
                      </div>
                      <div className="form-group ">
                        <label
                          style={{
                            fontSize: "15px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            color: "#353535",
                          }}
                        >
                          Latitude
                        </label>
                        <input
                          type="text"
                          value={formData.latitude}
                          readOnly
                          className="form-control branch-input-form-control"
                        />
                      </div>

                      <div className="form-group ">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <label
                            style={{
                              fontSize: "15px",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              color: "#353535",
                            }}
                          >
                            Longitude
                          </label>
                          <span
                            className="text-primary"
                            onClick={
                              !isTextFieldDisable ? openMapModal : undefined
                            }
                            style={{
                              cursor: isTextFieldDisable
                                ? "not-allowed"
                                : "pointer",
                              opacity: isTextFieldDisable ? 0.5 : 1,
                              fontSize: "15px",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              color: "#353535",
                              marginRight: "10px",
                            }}
                          >
                            Locate on Map
                          </span>
                        </div>
                        <input
                          type="text"
                          value={formData.longitude}
                          readOnly
                          className="form-control branch-input-form-control"
                        />
                      </div>
                      <div className="form-group">
                        {/* Empty space for alignment */}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "4rem" }}
          >
            <button
              type="button"
              className="branch-save-submit-btn btn btn-success"
              onClick={moveToNextTab}
            >
              {edit ? "Update" : "Save & Submit"}
            </button>
            {!edit ? (
              <button
                type="button"
                className="branch-save-submit-btn btn btn-success"
                style={{ marginLeft: "15px" }}
                onClick={handleCancel}
              >
                Cancel
              </button>
            ) : null}
          </div>
        </form>
      </div>

      {/* Map Modal */}
      {showMapModal && (
        <Modal
          className="modal-position"
          size="lg"
          show={showMapModal}
          onHide={closeMapModal}
          aria-labelledby="example-modal-sizes-title-lg"
          right
        >
          <Modal.Header>
            <Modal.Title
              id="example-modal-sizes-title-lg"
              style={{ color: "#001b30", marginRight: "500px" }}
            >
              {"Choose Location"}
            </Modal.Title>
            <XCircleblack
              className="cursor-pointer"
              onClick={closeMapModal}
              width="1.5em"
              height="1.5em"
              style={{ color: "#001b30" }}
            />
          </Modal.Header>
          <Modal.Body onClick={(e) => e.stopPropagation()}>
            <div className="gis-mapcontainer">
              {/* <LocationAtmComplete updateMapLocation={updateMapLocation} /> */}

              <div
                key={mapKey}
                className="assetFormMap"
                onClick={(e) => e.stopPropagation()}
              >
                <MapWrapper
                  headerStyles={{ display: "none" }}
                  coordinates={coordinates}
                  chooseCoordinates={chooseCoordinates}
                  zoom={zoomLevel}
                  closeMapModal={closeMapModal}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {/* Cancel Confirmation Modal */}
      <Modal
        show={showCancelModal}
        onHide={closeCancelModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Would you like to clear the input values?</p>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "right" }}>
          <button
            className="btn"
            style={{
              backgroundColor: "lightgray",
              color: "#000",
              marginRight: "10px",
            }}
            onClick={closeCancelModal}
          >
            No
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: "green",
              color: "#fff",
            }}
            onClick={confirmCancel}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>

      {loader && <Loader />}
    </>
  );
};

export default AddNewAtmForm;
